
import { Component, Emit, Provide, Vue } from 'vue-property-decorator';

@Component({})
export default class CheckBoxGroup extends Vue {
  @Provide() check = (value: string) => {
    this.onChange(value);
  };
  @Emit('onChange') onChange(value: string) {}
}
